import { Box, Typography, Stack } from '@mui/material';

import { ParIcon } from '@occc/ui-design-system';

const splitLayoutContainerStyles = {
  borderRadius: '9px',
  backgroundColor: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  width: '377px',
  height: '263px',
};

const leftSideStyles = {
  backgroundColor: '#E5E5E5',
  borderTopLeftRadius: '9px',
  borderBottomLeftRadius: '9px',
  flex: 1,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

const rightSideStyles = {
  backgroundColor: 'white',
  borderTopRightRadius: '9px',
  borderBottomRightRadius: '9px',
  flex: 1,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

const logoutButtonStyles = {
  backgroundColor: 'white',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 1,
  px: 1,
  py: 0.5,
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1.2,
  textTransform: 'capitalize',
};

const rightImageStyles = {
  width: '100%',
  height: '158px',
  objectFit: 'cover',
  objectPosition: 'center',
  borderRadius: '9px',
};

const sendButtonStyles = {
  backgroundColor: '#34C759',
  color: 'white',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 1,
  py: 0.75,
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1.2,
  textTransform: 'capitalize',
};

const parLogoStyles = {
  color: '#2f3452',
  width: '1em',
};

type KioskPreviewProps = {
  imageUrl: string;
};

export const KioskPreview = ({ imageUrl }: KioskPreviewProps) => {
  return (
    <Box sx={splitLayoutContainerStyles}>
      <Box sx={leftSideStyles}>
        <Box ml={3} mt={2} display='flex' alignItems='center' gap={0.5}>
          <ParIcon sx={parLogoStyles} />
          <Typography fontSize={8} textTransform='capitalize'>
            Retail Rewards
          </Typography>
        </Box>
        <Box
          ml={3}
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography variant='h4'>
            <span role='img' aria-label='Kiosk preview welcome emoji'>
              🥳
            </span>
          </Typography>
          <Typography variant='subtitle1' color='black'>
            Welcome to
            <br />
            Rewards!
          </Typography>
        </Box>
        <Box p={1}>
          <Box sx={logoutButtonStyles}>Logout</Box>
        </Box>
      </Box>

      <Box sx={rightSideStyles}>
        <Box px={1} pt={1}>
          <Box component='img' src={imageUrl} alt='Content Image' sx={rightImageStyles} />
        </Box>
        <Stack px={1} pb={1} gap={1} flexDirection='column' justifyContent='space-between'>
          <Box>
            <Typography color='black' fontSize={12} lineHeight={1.2} fontWeight={600}>
              Reward Unlocked!
            </Typography>
            <Typography color='black' fontSize={12} lineHeight={1.2}>
              Just enter your phone number at checkout.
            </Typography>
          </Box>
          <Box sx={sendButtonStyles}>Send to Phone</Box>
        </Stack>
      </Box>
    </Box>
  );
};
